import {Preferences} from '@capacitor/preferences';
import {DateTime} from "luxon";
import {InAppReview} from '@capacitor-community/in-app-review';

const LATEST_RATE_KEY = 'latest-rate-appeared-date'

export const useRate = (args: { dayJoined: string; }) => {
  const {dayJoined} = args;

  const saveLatestRateAppearedTime = async () => {
    await Preferences.set({
      key: LATEST_RATE_KEY,
      value: DateTime.local().toISO(),
    });
  }

  const getLatestRateAppeared = async () => {
    const ret = await Preferences.get({key: LATEST_RATE_KEY});
    return ret.value ? DateTime.fromISO(ret.value) : null;
  }

  const showRateAppPopupAndUpdateDate = async () => {
    await saveLatestRateAppearedTime();
    await InAppReview.requestReview();
  }

  const handleRateAppPopup = async () => {
    try {
      const latestDate = await getLatestRateAppeared();
      if (latestDate && Math.abs(latestDate.diffNow('day').days) >= 90) {
        await showRateAppPopupAndUpdateDate();
        return
      }

      if (Math.abs(DateTime.fromISO(dayJoined).diffNow('days').days) >= 14) {
        await showRateAppPopupAndUpdateDate();
        return;
      }
    } catch (e) {
      console.log(`Failed to show rate popup: ${e}`)
    }
  }

  return {
    handleRateAppPopup
  }
}
